import React from 'react'
import Field from '../../common/FormField'

const links = [
  {
    name: 'Website',
    desc: 'Enter your website link if relevant (i.e. www.mywebsite.com)',
    field: 'website'
  },
  {
    name: 'Twitter',
    desc: 'Enter your Twitter profile link',
    field: 'twitter'
  },
  {
    name: 'Facebook',
    desc: 'Enter your Facebook profile link',
    field: 'facebook'
  },
  {
    name: 'Instagram',
    desc: 'Enter your Instagram profile link',
    field: 'instagram'
  },
  {
    name: 'Pinterest',
    desc: 'Enter your Pinterest profile link',
    field: 'pinterest'
  },
  {
    name: 'LinkedIn',
    desc: 'Enter your LinkedIn profile link',
    field: 'linkedin'
  }
]

export default ({ data, onChangeFactory, disabled }) =>
  <fieldset>
    {links.map(({ name, desc, field }) =>
      <Field type="input" name={name} key={field}>
        <input
          type="text"
          placeholder={desc}
          value={data[field]}
          onChange={onChangeFactory(field)}
          disabled={disabled}
        />
      </Field>
    )}
  </fieldset>
